import './populate-result'
import Fuse from 'fuse.js'
import { populateResults, searchIndex } from './populate-result'
import { searchItem } from './components/searchitem'
import { updateMap } from './map'
const searchResult = document.querySelector('.reseller-search-result')
let post_list, fuse
const minSearchLength = 1
const searchInput = document.querySelector(`.reseller-search-input[data-search-id="reseller"]`)

// Fetch search index and initialize search.
function fetchSearchResults() {
    fetch(searchIndex)
        .then((blob) => blob.json())
        .then((datas) => {
            post_list = [...datas].map((data) => {
                return data
            })
            const options = {
                includeScore: true,
                shouldSort: true,
                minMatchCharLength: minSearchLength,
                useExtendedSearch: true,
                threshold: 0.2,
                keys: [
                    { name: 'title', weight: 0.6 },
                    { name: 'content', weight: 0.2 },
                    { name: 'cats', weight: 1 },
                    { name: 'city', weight: 1 },
                ],
            }

            fuse = new Fuse(post_list, options)
        })
        .catch((error) => {
            console.log(error)
        })
}
document.addEventListener('DOMContentLoaded', fetchSearchResults)

// Display search results.
function displayMatches() {
    results = fuse.search(searchInput.value)
    const htmlLang = document.querySelector('html').getAttribute('lang')
    const currentLang = htmlLang.split('-')[0]
    let results,
        timeoutId,
        markers = []

    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
        timeoutId = null
        if (searchInput.value.length < minSearchLength && results.length === 0) {
            populateResults()
            return
        }
    }, 300)

    const searchItems = results
        .map((post) => {
            const id = post.item.id
            const title = post.item.title
            const city = post.item.city
            const link = post.item.link
            const categories = post.item.categories
            const lat = post.item.lat
            const lng = post.item.lng
            const lang = post.item.lang

            if (lat || lng) {
                markers.push(post.item)
                return searchItem(id, title, city, link, categories, lat, lng, lang)
            }
        })
        .join('')

    if (results.length < 1 && searchInput.value.length > minSearchLength) {
        searchResult.innerHTML = /*html*/ `
                          <div class="no-results py-24">
                              <p class="text-center text-sm">${
                                  currentLang === 'sv'
                                      ? 'Inga resultat, prova något annat.'
                                      : 'No results, please try something else.'
                              }</p>
                          </div>`
    } else {
        searchResult.innerHTML = searchItems
        updateMap(markers)
    }
}

// Search on input.
document.addEventListener('keyup', function (e) {
    if (e.target.classList.contains('reseller-search-input')) {
        if (e.key === 'Escape') {
            e.target.value = ''
            populateResults()
            return
        }

        if (e.key.match(/^[a-z0-9\s\b]$/i) || e.key === 'Backspace' || e.key === 'Delete') {
            displayMatches()
        }
    }
})

// Search on filter change.
document.addEventListener('change', function (e) {
    if (e.target.classList.contains('filter')) {
        displayMatches()
    }
})
